import React from 'react';
import ReactDOM from 'react-dom';

// styles
import './styles/index.css';
import 'react-tippy/dist/tippy.css'
import 'openseadragon'
import Router from './Router';

ReactDOM.render(<Router />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js